import src from "IMAGE";
export default { src, width: 260, height: 40, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJWVlYqnp6eZubm5qqSkpJaYqm+ajK1Ann2bOY6Kqj+bQOsSfgqeieYAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
